export default __webpack_public_path__ + "static/media/PC-01.396442aa.jpg";